import React from 'react';
import { Box, Container, Typography, Grid, Link, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
		<Box
			component="footer"
			sx={{
				bgcolor: "background.paper",
				py: 6,
				mt: "auto",
				borderTop: 1,
				borderColor: "divider",
			}}>
			<Container maxWidth="lg">
				<Grid container spacing={4}>
					<Grid item xs={12} sm={4}>
						<Typography variant="h6" color="primary" gutterBottom>
							Bhagwat Geeta
						</Typography>
						<Typography variant="body2" color="text.secondary" paragraph>
							{t("footer.description")}
						</Typography>
						<Typography variant="subtitle2" color="text.secondary">
							{t("footer.tagline")}
						</Typography>
					</Grid>

					<Grid item xs={12} sm={4}>
						<Typography variant="h6" color="primary" gutterBottom>
							{t("footer.quickLinks")}
						</Typography>
						<Link
							component={RouterLink}
							to="/about"
							color="inherit"
							display="block"
							sx={{ mb: 1 }}
						>
							{t("footer.about")}
						</Link>
						<Link
							component={RouterLink}
							to="/about"
							color="inherit"
							display="block"
							sx={{ mb: 1 }}
						>
							{t("footer.contact")}
						</Link>
						<Link
							href="https://gita.blivix.com"
							color="inherit"
							display="block"
						>
							gita.blivix.com
						</Link>
					</Grid>

					<Grid item xs={12} sm={4}>
						<Typography variant="h6" color="primary" gutterBottom>
							{t("footer.poweredBy")}
						</Typography>
						<Link
							href="https://blivix.com"
							target="_blank"
							rel="noopener noreferrer"
							sx={{
								display: "block",
								mb: 2,
							}}>
							<img
								src="/icons/logo-192.png"
								alt="Blivix"
								style={{
									height: "34px",
									width: "34px",
									borderRadius: "6px",
									objectFit: "cover",
									transition: "all 0.3s ease",
								}}
							/>
						</Link>
						<Link
							href="https://blivix.com"
							target="_blank"
							rel="noopener noreferrer"
							color="inherit"
							underline="hover"
						>
							blivix.com
						</Link>
					</Grid>
				</Grid>

				<Divider sx={{ my: 3 }} />

				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						flexWrap: "wrap",
						gap: 2,
					}}>
					<Typography variant="body2" color="text.secondary">
						© {currentYear}{" "}
						<Link
							href="https://blivix.com"
							target="_blank"
							rel="noopener noreferrer"
							color="inherit"
							underline="hover"
						>
							blivix.com
						</Link>
						. {t("footer.copyright")}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{t("footer.madeBy")}{" "}
						<Link
							href="https://blivix.com"
							target="_blank"
							rel="noopener noreferrer"
							color="inherit"
							underline="hover"
						>
							Blivix
						</Link>
					</Typography>
				</Box>
			</Container>
		</Box>
	)
};

export default Footer;
